import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { themeOptions } from '../theme';
import DefaultLayout from '../components/layout/DefaultLayout/DefaultLayout';
import AppRoutes from './App.routes';
import { Provider } from 'react-redux';
import store from '../shared/redux/store';
import './App.css';
import Loading from './Loading';
import { RecaptchaProvider } from '../shared/google-recaptcha-v3/RecaptchaProvider';
import { AppProvider } from './App.Context';
import Settings from './Settings/Settings';
import InitializeGoogleAnalytics from '../shared/google-analytics';
import { useEffect } from 'react';

function App () {
  const theme = createTheme(themeOptions);

  useEffect(() => {
    InitializeGoogleAnalytics()
  })

  return (
    <Provider store={store}>
      <RecaptchaProvider >
        <ThemeProvider theme={theme}>
          <AppProvider>
            <Router>
              <Loading />
              <Settings />
              <DefaultLayout>
                <div className="Home__Content">
                  <AppRoutes />
                </div>
              </DefaultLayout>
            </Router>
          </AppProvider>
        </ThemeProvider>
      </RecaptchaProvider>
    </Provider>
  );
}

export default App;
